<p-blockui [blocked]="isLoading">
  <p-progress-spinner></p-progress-spinner>
</p-blockui>

<div class="flex flex-col gap-6 pb-[10rem]">
  <div class="flex flex-row justify-between">
    <div class="">
      <h1 class="main-title">Lista de sedes</h1>
      <p class="main-subtitle">
        Total de sedes: {{ totalRecords }}
      </p>
    </div>

    <div class="flex flex-row gap-3">
      @if(UserPermission.CREATE_OFFICE | hasPermission){
        <p-button severity="primary" type="button" (onClick)="onCreateOffice()">
          <span>Crear sede</span>
        </p-button>
        <p-button severity="primary" type="button" (onClick)="onBulkUpload()">
          <span>Carga masiva</span>
        </p-button>
      }
    </div>
  </div>

  <!-- Sección de filtros -->
  <app-office-filter
    [businessGroupOptions]="businessGroupOptions"
    [isLoading]="isLoading"
    (filterChange)="onFilterChange($event)"
    (clearFilters)="onClearFilters()"
  />

  <!-- Tabla listado de sedes -->
  <app-offices-list
    [data]="filteredData"
    [totalRecords]="totalRecords"
    [sortBy]="sortBy"
    [sortOrder]="sortOrder"
    [first]="paginationState().first!"
    [rows]="paginationState().rows!"
    (pageChange)="onPageChange($event)"
    (toggleSort)="toggleSort($event)"
    (handleConfirmChangeStatus)="handleConfirmChangeStatus($event)"
  />

  <app-confirmation-dialog
    [(visible)]="showStatusChangeDialog"
    type="warning"
    title="Cambiar de estado"
    [message]="changeStatusMessage"
    [confirmButtonText]="changeStatusButton"
    cancelButtonText="Cancelar"
    (onConfirm)="confirmStatusChange()"
    (onCancel)="cancelStatusChange()">
  </app-confirmation-dialog>

  <p-toast />
</div>
